export const MEASUREMENT_UNITS = {
    kilogram: 'kilogram',
    kg: 'kg',
    pound: 'pound',
    lbs: 'lbs'
};

export const EXTREMA_WEIGHT_VALUES = {
    minKg: 0.1,
    maxKg: 453.5,
    minLbs: 0.1,
    maxLbs: 999.9
};

export const MAX_REPS = 20;
